import { useCallback } from 'react';
import { useWorkFlowCanvas } from '../../../../contexts/CampaignFlowProvider';

export const useOnNodeChangeWorkFlowCanvas = () => {
  const { dispatch } = useWorkFlowCanvas();

  return useCallback(
    changes => {
      dispatch({
        type: 'ON-NODE-CHANGE',
        payload: {
          changes,
        },
      });
    },
    [dispatch],
  );
};
